import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';

@Injectable()
export class CommonRequestService {
  protected readonly _url = environment.backendUrl;
  protected readonly _urlCaseLogger = environment.backendUrlLogger;

  constructor() {}

  protected _getHttpHeaders(authToken: string): HttpHeaders {
    return new HttpHeaders().set('Authorization', `Bearer ${authToken}`);
  }
}
